import { TOURS } from "@/data/tours";

const COUNTRY_OF = {
  California: "United States", Nevada: "United States",
  "New South Wales": "Australia", Queensland: "Australia", Victoria: "Australia",
  England: "United Kingdom",
};

const places = new Set();
const countries = new Set(["India"]);
TOURS.forEach((t) => (t.route || []).forEach(({ state }) => {
  if (!state || state === "India") return;
  places.add(state);
  if (t.scope !== "india") countries.add(COUNTRY_OF[state] || state);
}));

export const DESTINATIONS_COUNT = places.size;
export const COUNTRIES_COUNT = countries.size;
export const TOURS_COUNT = TOURS.length;
export const YEARS_OF_TRUST = new Date().getFullYear() - 2010;
